<template>
  <el-form ref="lookupUserBySSN" :model="form" :rules="rules" label-width="15%" style="max-width: 600px" @submit.native.prevent="lookupClient">
    <el-alert class="mb-3" :title="errorMessage" type="error" show-icon v-if="errorMessage"></el-alert>
    <el-form-item label="SSN" prop="ssn">
      <masked-el-input v-model="form.ssn" :mask="'###-##-####'" placeholder="Social Security Number"></masked-el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="lookupClient" :loading="loading">Lookup Client</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import get from 'lodash/get';
import MaskedElInput from '@/components/form-item/MaskedElInput.vue';
import api from '@/api';
import { Required, SSN } from '@/util/formValidators';

export default {
  data() {
    return {
      loading: false,
      errorMessage: null,
      form: {
        ssn: '',
      },
      rules: {
        ssn: [Required, SSN],
      },
    };
  },
  methods: {
    clearInput() {
      this.form.ssn = '';
      this.errorMessage = null;
      this.$refs.lookupUserBySSN.resetFields();
    },
    async lookupClient() {
      this.errorMessage = null;
      try {
        await this.$refs.lookupUserBySSN.validate();
      } catch (e) {
        console.warn('form not valid', e);
        return;
      }

      this.$emit('searchStarted');
      this.loading = true;
      try {
        const response = await api.client.findBySSN(this.form.ssn);
        this.$emit('clientFound', response.data);
      } catch (e) {
        if (get(e, 'response.status') === 404) {
          this.$emit('clientNotFound', this.form.ssn);
        } else if (get(e, 'response.status') === 402) {
          this.errorMessage = 'Access denied. You do not have access to this client\'s office.';
        } else {
          throw e;
        }
      } finally {
        this.loading = false;
      }
    },
  },
  components: {
    MaskedElInput,
  },
};

</script>
